var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllproduct = function SvgAllproduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 26,
    fill: "none",
    viewBox: "0 0 120 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#E5673E",
    d: "M4 .25h108L119 13l-7 12.75H4a4 4 0 0 1-3.75-4V4A4 4 0 0 1 4 .25Z"
  })));
};
export { SvgAllproduct as ReactComponent };
export default "/_next/static/media/static/media/allproduct.68b08cdcb59f9859fbdef4c0c4871584svg";